import React from 'react';
import Visitor from "./Visitor";
import DailyAnalytics from "./DailyAnalytics";
import PeakHours from "./PeakHours";
import VisitorTop from "./VisitorTop";
import VisitorTimePie from "./VisitorTimePie";
import VisitorDualAxes from "./VisitorDualAxes";

const VisitorAnalytics = () => {
    return (
        <div className="visitor-analytics">
            <VisitorTop />
            <Visitor />
            <div className=" w-100 row">
                <div className="col-md-6 h-100">
                    <PeakHours />

                </div>
                <div className="col-md-6  h-100  ">
                    <VisitorTimePie />

                </div>
                {/*<AnaluzCustom />*/}
            </div>
            <DailyAnalytics />

               <VisitorDualAxes />
        </div>
    );
};

export default VisitorAnalytics;